<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <button mat-button class="buttonClose" type="button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    <div style="color: white; position: relative; top: 20px" class="move labelStyle pull-right dlg-drag-handle"
         cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
</h1>
<div class="modal-body" style="padding: 10px">
    <mat-tab-group [color]="'warn'">
        <mat-tab style="color: white" label="about">
            <div class="wrapInfo tabDiag">
                <label class="labelStyle ver">Digital Signage | Kiosk Player</label>
                <hr/>
                <label class="labelStyle ver">{{appType}}</label><br>
                <label class="labelStyle ver">{{appVersion}}</label><br>
                <label class="labelStyle ver">{{libVersion}}</label><br>
                <label class="labelStyle ver">{{extensionVersion}}</label><br>
            </div>
        </mat-tab>
        <mat-tab label="install">
            <div class="wrapInfo tabDiag ">
                <label class="labelStyle ver">Install signWatchdog</label>
                <hr/>
                <div class="centerContent2">
                    <button mat-raised-button class=" buttonWd" type="button"
                            (click)="onDownloadWin32()">Windows
<!--                        <mat-icon>download</mat-icon>-->
                    </button>
                    <button mat-raised-button class=" buttonWd" type="button"
                            (click)="onDownloadLinux()">Ubuntu/Mac
<!--                        <mat-icon>download</mat-icon>-->
                    </button>
                    <button mat-raised-button class=" buttonWd" type="button"
                            (click)="onDownloadAndroid()">Android
<!--                        <mat-icon>download</mat-icon>-->
                    </button>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="registration">
            <div class="wrapInfo tabDiag">
                <label class="labelStyle ver">remove player / station</label>
                <hr/>
                <button mat-raised-button class="infoButton buttonStart" type="button" (click)="onUnregister()">
                    {{unregister}}
<!--                    <mat-icon>logout</mat-icon>-->
                </button>
            </div>
        </mat-tab>


        <mat-tab label="debug">
            <div class="wrapInfo tabDiag">
                <label class="labelStyle ver">development</label>
                <hr/>
                <div class="centerContent2">
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onShowFPS()">show FPS
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onReadLog()">read log
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onClearLog()">clear log
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onAbnormalExit()">abnormal exit
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onTestSlow()">slow down
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onTestHung()">freeze
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onInfiniteMemLeak()">infinite leak
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onInfiniteDomLeak()">infinite dom
                    </button>
                    <button mat-raised-button class="infoButton buttonStart" type="button"
                            (click)="onLoseContext()">WEBGL loseContext
                    </button>
                  <button mat-raised-button class="infoButton buttonStart" type="button"
                          (click)="onClearErrors()">Clear errors
                  </button>
                  <button mat-raised-button class="infoButton buttonStart" type="button"
                          (click)="onThrowErrorTest()">Throw error
                  </button>
                  <button mat-raised-button class="infoButton buttonStart" type="button"
                          (click)="onShowErrors()">Show errors
                  </button>
                  <button mat-raised-button class="infoButton buttonStart" type="button"
                          (click)="onReboot()">reboot device
                    </button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
